import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Sections.css';

gsap.registerPlugin(ScrollTrigger);

const problems = [
  { icon: '01', title: 'Trading Ikut Emosi', text: 'Entry ikut perasaan, revenge trade lepas loss, dan tak pernah follow plan yang konsisten. Akaun makin susut.' },
  { icon: '02', title: 'Bergantung Signal Orang', text: 'Asyik ikut signal trader lain tanpa faham kenapa entry. Bila signal salah, tak tahu nak buat apa.' },
  { icon: '03', title: 'Tak Pandai Mark Zone', text: 'Tak tahu nak letak support resistance di mana. Selalu missed peluang atau entry salah tempat.' },
  { icon: '04', title: 'Risk Management Lemah', text: 'Lot size tak kira, SL pun tak letak. Satu trade boleh burn habis akaun dalam sekelip mata.' },
];

export default function ProblemSection() {
  const ref = useRef();
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo('.prob-head', { opacity: 0, y: 40 },
        { opacity: 1, y: 0, duration: 1, ease: 'power4.out', scrollTrigger: { trigger: ref.current, start: 'top 65%' } });
      document.querySelectorAll('.prob-card').forEach((card, i) => {
        gsap.fromTo(card, { opacity: 0, y: 40 },
          { opacity: 1, y: 0, duration: 0.9, delay: i * 0.12, ease: 'power4.out',
            scrollTrigger: { trigger: card, start: 'top 85%' } });
      });
      gsap.fromTo('.prob-bottom', { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.9, ease: 'power4.out', scrollTrigger: { trigger: '.prob-bottom', start: 'top 90%' } });
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <section className="sec prob" ref={ref}>
      <div className="container">
        <div className="prob-head">
          <span className="pill">MASALAH BESAR KORANG</span>
          <h2>Pernah tak rasa semua orang profit<br/>tapi kau je asyik <span className="gold-grad">rugi</span>?</h2>
        </div>
        <div className="prob-grid">
          {problems.map((p) => (
            <div className="prob-card" key={p.icon}>
              <span className="prob-num">{p.icon}</span>
              <h3>{p.title}</h3>
              <p>{p.text}</p>
            </div>
          ))}
        </div>
        <div className="prob-bottom">
          <p>Semua masalah ni, Adam Danish dah tulis penyelesaiannya dalam <strong>Buku TLP</strong>.</p>
        </div>
      </div>
    </section>
  );
}
